import { Button, Card, Divider, List, Tag, Typography } from "antd"
import { useEffect, useState } from "react";
import AddBin from "./AddBin";
import { Empty } from 'antd';
import ViewGarment from "../Garments/ViewGarment";
import bin_img from '../../../assets/dashboard/bin_img.png';
import ManageBinService from "../../../services/ManageBinService";
import { useNavigate } from "react-router";
import DashboardFilter from "./DashboardFilter";

const Dashboard = ({ userData }) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [displayBin, setDisplayBin] = useState([]);
    const [filteredBins, setFilteredBins] = useState([]);
    const [displayGarments, setDisplayGarments] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await ManageBinService.getBinData();
                console.log("Response:", response.data);

                const userData = JSON.parse(localStorage.getItem("userData"));

                if (userData && userData.data.dept === "21") {
                    const filteredData = response.data.filter(
                        (bin) => bin.bin_location === "dispatch_center" 
                        && bin.bin_full === "yes"
                    );
                    setDisplayBin(filteredData);
                    setFilteredBins(filteredData);
                } else {
                    setDisplayBin(response.data);
                    setFilteredBins(response.data);
                }
            } catch (error) {
                console.error("Error fetching bin data:", error);
            }
        };

        fetchData();
    }, []);


    const handleAddBin = (binData) => {
        console.log("Received Bin Data in Dashboard:", binData);

        setDisplayBin((prevBins) => {
            const updatedBins = [...prevBins, binData];
            console.log("Updated Bin Collection:", updatedBins);
            return updatedBins;
        });
    };

    const applyFilters = (filters) => {
        console.log(filters);

        if (!filters || filters.length === 0) {
            setFilteredBins(displayBin);
            console.log(displayBin);

        } else {
            const filtered = displayBin.filter((bin) => filters.includes(bin.bin_location));
            setFilteredBins(filtered);
        }
    };

    const handleCardClick = (bin) => {
        console.log("Clicked Bin Data:", bin);
        navigate(`/manage-bin/view-garment?bin_id=${encodeURIComponent(bin.bin_id)}&bin_location=${encodeURIComponent(bin.bin_location)}`);

    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Dashboard
                </Typography.Title>
                <Button type="primary" onClick={() => { setIsModalOpen(true) }}>Add Bin</Button>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <AddBin
                userData={userData}
                addBinModal={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                onAddBin={handleAddBin} />

            <DashboardFilter filterData={displayBin} onApplyFilters={applyFilters} />

            <div style={{ marginTop: 16 }}>
                {displayBin.length > 0 ? (
                    <List
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 2,
                            md: 3,
                            lg: 4,
                            xl: 5,
                        }}
                        dataSource={filteredBins}
                        renderItem={(bin) => (
                            <List.Item>
                                <>
                                    {bin.bin_location && (
                                        <Tag
                                            color={
                                                bin.bin_location === "washing"
                                                    ? "#87CEEB" // Sky Blue for washing
                                                    : bin.bin_location === "dispatch_center"
                                                        ? "#800080" // Purple for dispatch_center
                                                        : bin.bin_location === "garment_super_market"
                                                            ? "#FFC0CB" // Pink for garment_super_market
                                                            : bin.bin_location === "In Transit"
                                                                ? "#FFFF00" // Yellow for In Transit
                                                                : "#000000" // Default color if no match
                                            }
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                whiteSpace: 'nowrap',
                                                color:
                                                    bin.bin_location === "washing"
                                                        ? "#00000" // Black text for Sky Blue
                                                        : bin.bin_location === "dispatch_center"
                                                            ? "#FFFFFF" // White text for Purple
                                                            : bin.bin_location === "garment_super_market"
                                                                ? "#000000" // Black text for Pink
                                                                : bin.bin_location === "In Transit"
                                                                    ? "#000000" // Black text for Yellow
                                                                    : "#FFFFFF", // Default text color for Black
                                                width: '50%',
                                                height: '100%',
                                                textAlign: 'center',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {bin.bin_location === "washing"
                                                ? "Washing"
                                                : bin.bin_location === "dispatch_center"
                                                    ? "Transit Center"
                                                    : bin.bin_location === "garment_super_market"
                                                        ? "G S M"
                                                        : bin.bin_location === "In Transit"
                                                            ? "In Transit"
                                                            : "Unknown"}
                                        </Tag>
                                    )}

                                    <Card
                                        bordered={false}
                                        size="small"
                                        style={{
                                            textAlign: "center",
                                            borderRadius: 8,
                                            width: '50%',
                                            height: '50%',
                                            boxShadow: 'none',
                                        }}
                                        onClick={() => handleCardClick(bin)}
                                        cover={<img src={bin_img}
                                            style={{ marginBottom: '-20px' }} />
                                        }
                                    >

                                        <div style={{
                                            position: 'absolute',
                                            top: '53%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            color: 'white',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            <p style={{
                                                height: 24,
                                                color: 'black',
                                            }} size='small'><strong>{bin.bin_name}</strong></p>
                                        </div>
                                    </Card>
                                    <Tag
                                        color={bin.bin_full === "yes" ? "#87d068" : "transparent"}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            whiteSpace: "nowrap",
                                            marginBottom: "-10px",
                                            color: bin.bin_full === "yes" ? "white" : "black",
                                            width: "50%",
                                            height: "100%",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            border: bin.bin_full === "yes" ? "none" : "1px solid black",
                                        }}
                                    >
                                        {bin.total_quantity || 0} Pcs
                                    </Tag>

                                </>
                                <Divider />
                            </List.Item>
                        )}
                    />
                ) : (
                    <Empty />
                )}
            </div>
        </>
    );
};
export default Dashboard;